import { RoutingNode } from 'hooks/useRouteCalculator/routing-graph';
import { RootState } from 'redux/root';
import urlPaths from 'static/constants/enums/urlPaths';

const membershipVerificationPageRouting: RoutingNode = {
    forwardEdges: [
        {
            destination: urlPaths.membershipVerificationComplete,
            condition: () => true,
        },
    ],
    backwardEdges: [
        {
            destination: urlPaths.membershipQuestion,
            condition: () => false,
        },
    ],
    forAllForwardEdges: (state: RootState) => {
        return state.membership.membershipVerificationValid;
    },
};

export default membershipVerificationPageRouting;
